import { Complete } from "@/components/common/Complete";
import {
	diaryByIdQueryOptions,
	useDiaryByIdQuery,
} from "@/features/diaries/api";
import useCountDueObservations from "@/features/observations/hooks/useCountDueObservations";
import { createFileRoute } from "@tanstack/react-router";
import { CheckCircle2 } from "lucide-react";

const EntryComplete = () => {
	const { diaryId } = Route.useParams();

	const { isFetching } = useDiaryByIdQuery(diaryId as string);

	const remainingEntries = useCountDueObservations(diaryId as string);
	const isDue = Number(remainingEntries) > 0;

	return (
		<Complete
			title="Entry Recorded Successfully"
			description={
				isDue
					? `There are ${remainingEntries} more ${
							remainingEntries === 1 ? "entry" : "entries"
						} pending for this patient. Please ensure all required assessments are completed.`
					: "All required entries for this patient have been completed. The patient's record is now up to date."
			}
			icon={CheckCircle2}
			isLoading={isFetching}
			loadingText="Processing Entry"
			loadingDescription="Please wait while we save the entry..."
			primaryButton={{
				text: "Return to Patient",
				to: "/patients/$diaryId",
				params: { diaryId },
			}}
		/>
	);
};

export const Route = createFileRoute(
	"/_app/diaries/$diaryId/observation/$observationId/entry/$entryId/complete/staff",
)({
	component: EntryComplete,
	loader: async ({ params, context }) => {
		const diary = await context.queryClient.ensureQueryData(
			diaryByIdQueryOptions(params.diaryId),
		);
		return {
			diary,
		};
	},
});
